import React from 'react'
import './App.css'
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom"
import { routes } from './routes'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {routes.map((route) => {
          return (
            <Route
              key={route.name}
              path={route.path}
              element={route.element}
            />
          )
        })}
      </Routes>
    </BrowserRouter>
  )
}

export default App
